import { transport } from 'config/transport';

export function callApiGetSchoolAbsences(month, year) {
    return transport.get(`/mamnon/absences/school`, { params: { month, year } });
}
